import { css, font, fontWeight, palette, space, theme } from 'bumbag';
import medipassTheme from 'bumbag-theme-medipass';
const BumbagTheme = {
  ...medipassTheme,
  global: {
    styles: {
      // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.
      base: props => css`
        html,
        body {
          background-color: ${palette('white600')(props)};
          overflow-y: scroll !important;
          -webkit-overflow-scrolling: touch !important;
          min-height: 100vh;
        }

        body: {
          overflow-x: hidden;
        }

        body,
        button,
        input,
        select,
        textarea {
          font-family: ${font('default')(props)};
        }

        html,
        body,
        #root {
          width: 100%;
          font-weight: ${fontWeight('normal')(props)};
          font-display: swap;
        }

        .input.input.input:not(select) {
          padding: 1.3rem 0.8rem;
        }

        @media screen and (max-width: 400px) {
          html,
          body {
            font-size: 14px !important;
          }
        }
      `,
    },
  },
  fonts: {
    ...medipassTheme.fonts,
    importUrls: [],
    heading: 'Open Sans, sans-serif',
    default: 'Open Sans, sans-serif',
  },
  palette: {
    ...medipassTheme?.palette,
    primary: '#1C69E8',
    primary100: '#6096EF',
    primary200: '#4987ED',
    primary300: '#3378EA',
    primary400: '#2f75ea',
    primary500: '#1C69E8',
    primary600: '#155cd0',
    primary700: '#195FD1',
    primary800: '#1654BA',
    primary900: '#144AA2',
    secondary: '#d10069',
    secondary100: '#f5cee1',
    secondary200: '#f7a6cf',
    secondary300: '#ed4c9d',
    secondary400: '#e70073',
    secondary500: '#d10069',
    secondary600: '#b7005c',
    secondary700: '#98004c',
    secondary800: '#500016',
    secondary900: '#20000f',
    success: '#57AD68',
    success100: '#DDEFE1',
    success200: '#89C695',
    success300: '#68B577',
    success400: '#65b474',
    success500: '#57AD68',
    success600: '#4b9a5b',
    success700: '#3D7949',
    success800: '#3c7748',
    success900: '#2C5734',
    warning: '#F1C40F',
    warning100: '#FCF3CF',
    warning200: '#F5D657',
    warning300: '#F1C40F',
    warning400: '#f2ca26',
    warning500: '#F1C40F',
    warning600: '#D9B00E',
    warning700: '#C19D0C',
    warning800: '#A88906',
    warning900: '#A9890B',
    danger: '#E5494D',
    danger100: '#FBE4E4',
    danger200: '#ED8082',
    danger300: '#E85B5F',
    danger400: '#E96266',
    danger500: '#E5494D',
    danger600: '#CE4245',
    danger700: '#B73A3E',
    danger800: '#AE373B',
    danger900: '#A03336',
    info: '#73BAFF',
    info100: '#E3F1FF',
    info200: '#C7E3FF',
    info300: '#ABD6FF',
    info400: '#83c1fc',
    info500: '#73BAFF',
    info600: '#68A7E6',
    info700: '#5C95CC',
    info800: '#5f8cb9',
    info900: '#5182B3',
    tertiary: '#0A0524',
    tertiary100: '#545066',
    tertiary200: '#3B3750',
    tertiary300: '#231E3A',
    tertiary400: '#1e1a32',
    tertiary500: '#0A0524',
    tertiary600: '#060316',
    tertiary700: '#090520',
    tertiary800: '#08041D',
    tertiary900: '#070419',

    white800WithTransparency: 'rgba(230, 230, 230, 0.9)',
    grayDisabled: '#616161',
  },
  breakpoints: { ...medipassTheme?.breakpoints, checkout: 400, mobile: 600 },
  Card: {
    // @ts-expect-error
    ...medipassTheme?.Card,
    styles: {
      // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.
      base: props => css`
        @media screen and (max-width: ${theme('breakpoint.mobile')(props)}px) {
          padding: ${space(3)(props)}rem;
          border-radius: 0px;
        }
      `,
    },
  },
  Checkbox: {
    ...medipassTheme?.Checkbox,
    Icon: {
      ...medipassTheme?.Checkbox?.Icon,
      // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.
      checked: props => css`
        background-color: ${palette('primary')(props)};
        &::before {
          border: 0.15rem solid white;
          color: white;
          border-left-width: 0;
          border-top-width: 0;
        }
      `,
    },
  },

  Input: {
    styles: {
      base: (props: any) => css`
        ${medipassTheme.Input.styles.base(props)};
        color: ${palette('black')(props)};
        border: 1px solid ${palette('gray700')(props)};
      `,
      placeholder: (props: any) => css`
        color: ${palette('gray800')(props)};
      `,
    },
  },
  Divider: {
    styles: {
      // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.
      base: props => css`
        margin-top: ${space(2, 'major')(props)}rem;
        margin-bottom: ${space(2, 'major')(props)}rem;
      `,
    },
  },
  Label: {
    ...medipassTheme?.Label,
    styles: {
      ...medipassTheme?.Label?.styles,
      base: css`
        ${medipassTheme?.Label?.styles?.base};
        font-weight: 600;
      `,
    },
  },
};
export default BumbagTheme;
